/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const AddMyEmailBody = zod.object({
  email: zod.email().describe('The email address to add as a secondary'),
});

export type AddMyEmailBody = zod.input<typeof AddMyEmailBody>;
export type AddMyEmailBodyOutput = zod.output<typeof AddMyEmailBody>;
